import { z } from 'zod';
import { IMinimizedProfession, minimizedProfessionSchema } from './IMinimizedProfession';

// Schemas (concrete form for runtime validation)
export const professionWithActiveTagsSchema = minimizedProfessionSchema.extend({
	activeTagsIds: z.array(z.string()),
});

// Types (generic for TypeScript consumers)
export type IProfessionWithActiveTags<T extends IMinimizedProfession> = T & {
	activeTagsIds: string[];
};
